import { SVGProps } from 'react';

const Cherry = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 14c2.5-2 5 .24 5 3a5 5 0 0 1-10 0c0-2.76 2.5-5 5-3m10 0c-2.5-2-5 .24-5 3a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3M12 2c2.86 4.67 5.71 7 10 7 0-2.33-4.29-7-10-7-.71 3.25-1.78 9.09-5 12m10 0c-.06-3-3.34-9.62-5-12"
    />
  </svg>
);
export default Cherry;
